<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter">
<header>
<h1 class="topictitle1" id="ch6"><a href="#/nav#nch6"><span class="section_number">CHAPTER 1</span><br/><span class="title">THE LOWLIEST SUBJECT OF THE SORCERESS QUEEN</span></a></h1>
</header>
<p>“Shit,” muttered Anand, the word that summed up his existence. He had been knocked to the sand by a blowfly as big as himself.
            It crawled over his prostrate body and mopped his face with its pulpy mouthparts. Anand kicked out from under the fly, then
            stood and used his batting pole to beat it back into flight. He wiped his face, and sighed before resuming his harness.
         </p>
<p>The morning was typical for him, stinking and noisy with hovering insects as he lugged a vat of human waste away from Mound
            Cajoria. The most merciless of gods, Sun, was shining with all His cruelty and Anand sweated and strained as he trudged through
            a stretch of scorching sand. He beat his feet over the flattest part of each sand grain and avoided those with edges that
            could slice through his sandals.
         </p>
<p>At last he reached his destination, a density of weeds on Cajoria’s northwest border. He looked up at a stalk of mint leaves
            and took a moment to rest in its fragrant shade. Once he caught his breath, he pulled back a leaf-tarp and dumped his loathsome
            cargo. The flies that had shadowed him dropped from the air to converge on the waste. The fattest of them buzzed her wings,
            scattering the others as she crowded them off the muck.
         </p>
<p>As one end of her ate, the other sank its abdomen into the moisture to lay an egg. In her compound eyes, Anand saw a thousand
            reflections of himself, indistinct and tiny, one of the countless masses. When the fly turned its iridescent body, he saw
            himself in a large and single reflection: a brown-skinned boy with defiant eyes, strong limbs, and hair as black and glossy
            as tar. He smiled to see his mustache had thickened. It prompted him to finger the fifteen chits he wore around his neck,
            one for each of his years. <i>I am almost a man, </i>he thought, but then he frowned.
         </p>
<p><i>What kind of life is this for a man?</i></p>
<p>Blowflies interrupted Anand’s thoughts when they flew back to fight over the waste. Their buzzing made his skull vibrate with
            a terrible ache. He wanted to kill the flies with the sharp end of his batting pole, but that privilege belonged to the sons
            of the hunting caste. And as for those hunters . . .
         </p>
<p>Where were they? They should have been there to slay these pests and then port their corpses to the merchants. From the faint
            sound of it, Anand figured the hunters were deeper in the weeds and locked in some delightful combat. He wandered into the
            thicket to see what made them whoop and holler.
         </p>
<p>He followed their voices to a dandelion flower that had just turned to a great and towering seed clock. Under its leaves were
            several boys of Anand’s age surrounding a black, glistening centipede. The creature was huge and hairy and looked to be two-headed
            as it rose up on both ends and waved its hundred claws. Scattered over its loamy home were droppings full of bones and a skull
            from a human it had eaten.
         </p>
<p>“That’s the head, to the left,” shouted Skylo, a young man of sixteen with yellowish skin and leaf-green eyes. He pointed
            to the true head with pincers below its mouth, the points of which were beaded with poison. The boys ran under the centipede’s
            safer end where they thrust spears between its belly scales. Each puncture sent the creature into violent convulsions . . .
            but didn’t kill it. As it snapped and thrashed, it whipped the boys with its legs and knocked them to the ground. It rose
            up, turned on them, and then lunged with its pincers. The boys ran under leaf cover, laughing when it missed them.
         </p>
<p>Weak and leaking blood, the centipede wobbled as it poised to strike again but when its head dropped, the rest of its body
            collapsed on the sand. The hunters ran in with their swords. Skylo skewered its brain as the rest chopped off its legs. Nearby
            was a hollowed acorn that one boy played like a barrel drum. Another joined him and started a chant. The rest picked up the
            centipede’s legs and danced with them around the corpse.
         </p>
<p>As he spied on them, Anand was filled with an envy that choked him from inside. He wondered if he had ever known such joy
            in his life. His envy grew as he watched the hunters climb the stalk of the seed clock. Skylo was the first to reach the seeds
            and plucked a few by their stems. At their ends were the fluffy domes of threads that caught the wind. He widened his arms,
            waited for a breeze, then jumped.
         </p>
<p>Anand watched as the boy bobbed and floated before he alighted on a distant barley comb. After Skylo released the seeds, he
            bounced down the spiral of the barley stalk’s leaves. When he reached the ground, he ran back, eager to do it again. He paused
            when he noticed Anand peering from behind the pebble.
         </p>
<p>“Step out from behind that pebble!” Skylo commanded and Anand complied. He saw the hunter recoil at the sight of his dark
            skin and his rags.
         </p>
<p>“Why aren’t you at work?” Skylo asked.</p>
<p>“Why aren’t <i>you</i>?” Anand whispered, and turned away.
         </p>
<p>“<i>What?</i> What did you say?”
         </p>
<p>Anand was quiet.</p>
<p>“Don’t dare speak to me, shit-scraper, especially like that,” said the hunter, pinching his nose as if Anand stank. “Hang
            your head and apologize or we can find a centipede to throw you to.”
         </p>
<p>“I’m sorry,” Anand said, as he turned toward Skylo and knelt. After a moment of silent shaming, the hunter ran back to the
            others.
         </p>
<p>Anand was dragging his pole back to the vat when he heard a thump and a muffled scream. He turned in the sound’s direction
            and froze to see a bloodsucker flea with Skylo bleeding in its barbed fore-claws. The bristled, disc-like monster was five
            times as tall as a man, crouching on powerful hind legs. Anand felt his heart jump into his head, beating like the acorn drum
            in his ears.
         </p>
<p>The flea clamped its head around Skylo’s torso. A dagger-like stipe emerged from its mouth and plunged between his ribs. Dual
            suckers from deeper in the mouth slithered over the boy’s chest, then sank into the incision. With a sickening slurp, Skylo
            was turned to a bloodless husk. The flea’s body was translucent and Anand watched as its abdomen reddened and bloated with
            blood.
         </p>
<p>“Fleas!” Anand shouted to the others climbing to the seeds, but they were too distant and lost in their chatter to hear him.
            The bloodsucker dropped the shriveled corpse as tiny antennae popped from its head and waved their hairy sensors. The flea
            caught Anand’s scent, pivoted towards him, then crouched to spring. Anand knew it was useless to run. He dropped to his knees
            and held up the sharp end of his pole.
         </p>
<p>Anand jerked upright when the flea jumped. As the insect dropped on him, he thrust the pole upwards and pierced its middle.
            The flea toppled, pressing Anand to the sand, with its wound smearing him with human and insect blood. He was excited he had
            killed it, but he knew fleas traveled in hordes, so he reached for his dagger as he wriggled out. “Fleas!” he shouted, running
            towards the seed clock. <i>“Fleas!”</i></p>
<p>Once the boys heard him, Anand raced to the open sand under cover of the lowest weeds. The hunters leapt to the sand to run
            and hide.
         </p>
<p>Dozens of fleas were plummeting into the weeds as Anand ran. He heard the hunters’ screaming and then their sudden silence
            as the fleas drained their blood. Zigzagging through a rain of fleas, Anand ran over the sand and reached the closest of the
            warning towers built among the weeds. He scrambled up a ladder to a platform under a wooden bell with a scent-bladder tied
            to a post at his right.
         </p>
<p>Anand slashed the bladder with his knife, releasing a powder of pungent <i>alarm-scent, </i>then grabbed the rope that trailed from the bell. As he swung up and into the air, a flea sprang at him. Anand raised his
            feet, kicking into the flea’s head and sending it into a spiraling fall. As the bell sounded a warning to the humans, the
            flea landed on its side, righted itself, and attacked again.
         </p>
<p>The flea was in mid-leap when an arrow pierced it, sending it into a spin. Anand jumped from the rope to the platform to see
            a leaf-cutter sentry ant rushing over the sand, its antennae a blur as they waved. Riding on the back of the sentry was its
            master, a human soldier from the border patrol nocking his bowstring.
         </p>
<p>Anand watched the ant’s antennae twitch in the direction of the fleas as she raised her gaster and sprayed <i>recruit-scent</i> on the breeze. Within moments, dozens of sentry ants and their human riders rushed into the weeds, flushing out the fleas.
            As the bloodsuckers jumped up, the humans pierced them with spears and arrows. The ants rushed to the fallen fleas and used
            their pincers to slice through their bellies and shear their legs.
         </p>
<p>Atop the platform, Anand caught his breath as he watched the fleas retreating north, vaulting over the weeds. Smaller ants
            without riders converged on the flea corpses, slicing them into pieces to haul away in a column. Surviving hunter-boys emerged
            from the cracks of rocks or pebbles they had burrowed under. Anand almost grinned to see one boy had lodged himself in the
            ribs of a fallen but poisonous mushroom and his skin was swollen with itchy bumps. A moment later, Anand was shaking, waiting
            under the bell as a group of officers abandoned their ants to climb the tower he occupied. Their honey-colored armor creaked
            as they took the rungs. Anand feared these soldiers more than he feared the fleas. He kept his head down as they mounted the
            platform and dared not look them in the face.
         </p>
<p>“Look up,” said their captain. Anand revealed his dark face and the clipped earlobe that identified his status.</p>
<p>“Good gods. He’s from the midden,” said a soldier, pinching his nose.</p>
<p>“And he’s got skin as brown as a roach-eater,” said another.</p>
<p>“This entire tower is polluted,” said the captain. “It will have to be chopped down and rebuilt.”</p>
<p>He addressed Anand but did not look in his eyes. “We must cut off your arm, middenite, for polluting royal property. Stick
            it out . . . left or right as you wish.”
         </p>
<p>From the corner of his eye, Anand could see the captain’s skin was so fair that he had blue blood pulsing in the veins of
            his temple.
         </p>
<p>“Good soldier, allow me to speak,” said Anand, staring down.</p>
<p>“What’s this?” the captain asked, surprised at the outburst. “You dare speak to me?”</p>
<p>“I sounded the alarm because others were under attack—it was not to save myself,” said Anand surprising himself. “Several
            hunter-boys died, but I see that some live—thanks to the keen aim of you and your men.”
         </p>
<p>“That’s true, Captain,” said a soldier in the back. “The survivors all pissed themselves . . . unlike this one.”</p>
<p>The captain sighed and stared at his sword with its cunning engraving of Mantis, the war goddess. “I’m not going to ruin my
            blade with the blood of some filthy middenite,” he said. “Come on, men. We must collect the husks of the dead and return them
            to their families. And you,” he said to Anand, “should praise Lord Grasshopper for His mercy.”
         </p>
<p>Anand knew not to thank the soldiers as they filed down, for even his gratitude was polluted. Besides, he had new worries.
            He would be late in returning to the midden. Despite it being the most reviled place in all Cajoria, he hurried home, wondering
            what punishment his foreman had in mind.
         </p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter_1.vue?6702a934